// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__8ZEJl","control":"Checkout_control__b3NlP","actions":"Checkout_actions__Z2g+Y","submit":"Checkout_submit__AED3-","invalid":"Checkout_invalid__taZXG"};